import { Opcodes } from '@kaetram/common/network';

import type Game from '../game';

export default class PointerController {
    public questTarget: { gridX: number; gridY: number } | null = null;

    public constructor(private game: Game) {}

    public create(_id: string, type: Opcodes.Pointer, _name?: string): void {
        if (type === Opcodes.Pointer.Location || type === Opcodes.Pointer.Entity) return;
    }

    public setToPosition(_id: string, x: number, y: number): void {
        let { tileSize } = this.game.map;

        this.questTarget = { gridX: Math.floor(x / tileSize), gridY: Math.floor(y / tileSize) };
    }

    public setToEntity(): void {
        //
    }

    public setRelative(): void {
        //
    }

    public setQuestTarget(gridX: number, gridY: number): void {
        this.questTarget = { gridX, gridY };
    }

    public clean(): void {
        this.questTarget = null;
    }

    public resize(): void {
        //
    }

    public update(): void {
        //
    }
}
